import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useContent } from '../../context/ContentContext';
import { resolveHomeVerses } from '../../data/homeVerses';
import RichTextField from './RichTextField';

export default function EditableVerseLine({ index, field, tag: Tag = 'span', className = '' }) {
  const { isEditing } = useAuth();
  const { getContent, setContentValue } = useContent();
  const verses = resolveHomeVerses(getContent);
  const fieldKey = field === 'ref' ? 'reference' : 'text';
  const value = verses[index]?.[fieldKey] || '';

  const saveValue = (nextValue) => {
    const nextVerses = verses.map((verse, idx) =>
      idx === index ? { ...verse, [fieldKey]: nextValue } : verse
    );
    setContentValue('home.verses.items', nextVerses);
  };

  return (
    <RichTextField
      isEditing={isEditing}
      tag={Tag}
      className={className}
      value={value}
      onChange={saveValue}
    />
  );
}
